import api from "@/api.js";

export default {
  state: {},
  mutations: {},
  actions: {
    async sendContactForm({ commit }, payload) {
      await api.post("simpleSoftwareContactForm", payload);
    }
  },
  getters: {}
};
